import * as moment from 'moment-timezone';
import { map } from 'rxjs/operators';
import { IResponse } from 'src/app/shared/models/app';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { SessionStorageService } from 'ngx-webstorage';
import { transform } from 'lodash';
import { DashboardView, DateFormat } from 'src/app/core/constants/app.constant';
import { OrderApi } from 'src/app/core/constants/api.constant';
import { MatDialog } from '@angular/material/dialog';


@Injectable({
  providedIn: 'root'
})

export class HomeService extends BaseService {
  constructor(protected http: HttpClient, private http2: HttpClient,
    private datePipe: DatePipe,private cache:CacheResolverService,private sessionStorage:SessionStorageService,
    private dialog: MatDialog,) {
      super(http);
    }

    reservationsLoaded=false;
    reservations$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    reservationsUpdate$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    refreshWaste$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    rejectedCount$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    _dashboardDate = null;
    rejectionNotificationData$: BehaviorSubject<any> = new BehaviorSubject<any>(null);   
    dashboardView$: BehaviorSubject<DashboardView> = new BehaviorSubject<DashboardView>('dayboard');


  dismissMaintenanceAlert(appMaintenanceNum,userDetailNum){
    let dismissObj:any = {
      appMaintenanceNum : appMaintenanceNum,
      userDetailNum : userDetailNum
    }
    dismissObj=JSON.stringify(dismissObj)
    return super.post(this.apiConfig.util+'/api/user/appmaintenance/dismiss', dismissObj)
  }

  resetReservations () {
    this.reservationsLoaded = false;
    return this.reservationsLoaded;
  }

  getManufacturerOrders(status:string, currentPage:number, reservationId:string = null) {
    let params = {
      customerShipToNum: this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo),
      reservationId : reservationId
    };
    return super.post(this.apiConfig.config + '/api/config/orderstub/reservations?status=' + status + '&page=' + currentPage, params);
  }

  searchForExistingSchedule(data:any) {
    return super.post(this.apiConfig.patient + '/api/orderstub/patientvisit', data);
  }

  getManufacturerOrderCount(isMobile){
    let params = {
      customerShipToNum: this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo)
    };
    var retVal = {};
    if (!this.reservationsLoaded) {
      retVal = super.post(this.apiConfig.config+'/api/config/orderstub/reservation', params).subscribe((response:IResponse)=> {
        if (response && response.data) {
          if (response.data.manufacturerOrderCount) {
            response.data.isMobile = isMobile;
            this.reservationsLoaded = true;
            this.reservations$.next(response.data);
          }
          this.reservationsUpdate$.next(response.data);
        }
      });
    }
    return retVal;
  }


  getReservationCountAfterSchedule () {
    let params = {
      customerShipToNum: this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo)
    };
    super.post(this.apiConfig.config+'/api/config/orderstub/reservation', params).subscribe( (response:IResponse)=> {
      if (response && response.data) {
        this.reservationsUpdate$.next(response.data);
      }
    })
  }

  isReservationsLoaded() {
    return this.reservationsLoaded;
  }

  getPatients(dateField) {


      const datefld =moment(dateField);

    return super.fetch(this.apiConfig.util + '/api/dayboard/patient', { params: { date:datefld.format()} }).pipe(map((response: IResponse) => {
      let retVal = {
        patientsCompleted: [], patientsInProgress: [], patientsNotStarted: [], patientsCancelled: [],
        patientsScheduled: []
      };
      if (response.data) {
        response.data.forEach((value: any) => {


          switch (value.type) {
            case 'In Progress':
              retVal.patientsInProgress.push(value);
              retVal.patientsScheduled.push(value);
              break;
            case 'Completed':
              retVal.patientsCompleted.push(value);
              break;
            case 'Not Started':
              retVal.patientsNotStarted.push(value);
              retVal.patientsScheduled.push(value);
              break;
            case 'Cancelled':
              retVal.patientsCancelled.push(value);
              break;
          }
        });
      }
      return retVal;
    }));

  }

  loadRecurringOrders(loadFlag, date) {
    let url = this.apiConfig.config + '/api/recurring/load';
    return super.post(url, { loadFlag: loadFlag, loadDate: moment(new Date(date)).format('MM/DD/YYYY') })
  }

  getOrder(dateField) {


    const datefld =moment(dateField);
    return super.fetch(this.apiConfig.util + '/api/dayboard/order',
      { params: { date:  datefld.format() } });
  }

  getInventories(dateField: Date) {
    return super.fetch(this.apiConfig.util + '/api/dayboard/inventory', { params: { date: moment(dateField).format('YYYY-MM-DD') } });
  }

  getSpecialProducts() {
    return super.post(this.apiConfig.config + '/config/specialproducts', {}).pipe(map((response: IResponse) => {
      this.cache.set(CacheConstant.LocalStorage.SpecialProducts, response.data.specialProducts);
      this.cache.set(CacheConstant.LocalStorage.ProductValidations, response.data.productValidations);
      this.cache.set(CacheConstant.LocalStorage.nonOrderableMaterialIds,response.data.nonOrderableMaterialId);
    }))

  }

  getUomsList() {
    return super.fetch(this.apiConfig.config + '/api/uom')
  }

  getUoms(){
    return super.fetch(this.apiConfig.config + '/api/uom', { }).pipe(map((response: IResponse) => {
      this.cache.set(CacheConstant.LocalStorage.Uoms,response.data);
    }));

  }
  getShipmentDetails(dateField, vendorType, searchType, id,shippingNum) {
    let paramsObj = shippingNum ? {params:{vendor:vendorType,type:searchType,id:id,shippingNum:shippingNum}}:{params:{vendor:vendorType,type:searchType,id:id}};
    return super.fetch(this.apiConfig.util + '/api/dayboard/shipmentorders',
    paramsObj).pipe(map((response: IResponse) => {
        if (response.data) {
          return this.transformDataforSentUnsent(dateField, response.data, 'Shipment');
        }

     }));
}
  getOffline(dateField){


    const datefld =moment(dateField);
    return super.fetch(this.apiConfig.util + '/api/dayboard/offline',
     { params: { date:  datefld.format() } }).pipe(map((response: IResponse) => {
       if(response.data){
       return this.transformData(dateField,response.data);
       }

      }));
  }

  getUnsent(dateField:Date){
    const datefld =moment(dateField);
    return super.fetch(this.apiConfig.util + '/api/dayboard/unsentorders',
    { params: { date:  datefld.format()   } }).pipe(map((response: IResponse) => {
      if(response.data){
      return this.transformDataforSentUnsent(dateField,response.data,'Unsent');
      }

      }));
  }

  getSent(dateField:Date){
    const datefld =moment(dateField);
    return super.fetch(this.apiConfig.util + '/api/dayboard/sentorders',
    { params: { date:  datefld.format()   } }).pipe(map((response: IResponse) => {
      if(response.data){
        return this.transformDataforSentUnsent(dateField,response.data,'Sent');
      }

      }));
  }



  markAllOfflineOrders(request) {
    return super.patch(this.apiConfig.order + '/api/offline/status/complete', request);
  }
  getSentOrdersETA(request){
    return super.post(this.apiConfig.util + '/order/get/eta',request).pipe(map((response: IResponse) => {
      let convertToArray = Object.entries(response.data).map(e=> {
      let ETAObj = {customerOrderNum: null, status: null}
                                ETAObj.customerOrderNum = e[0];
                                ETAObj.status = e[1];
                                return ETAObj;
                            });
                            return convertToArray;
    }));
  }

  orderPlaced(id) {
    return super.patch(this.apiConfig.order + '/api/offline/' + id + '/complete', { params: {} });
  }

  sendOrder(id) {
    return super.patch(this.apiConfig.order + '/api/order/' + id + '/status/Sent', { params: {} });
  }

  sendOrders(request) {
    return super.patch(this.apiConfig.order + '/api/orders/status/Sent', request);
  }
  moveOrders(request) {
    return super.patch(this.apiConfig.order + '/api/orders/status/Offline', request);
  }
  removeOrder(id) {
    return super.delete(this.apiConfig.order + '/api/offline/' + id);
  }
  removeUnsentOrder(id) {
    return super.delete(this.apiConfig.order + '/api/order/' + id);
  }

  updateAllOrdersAsCancel(request) {
    return super.patch(this.apiConfig.order + '/api/orders/status/Cancel', request);
  }

  cancelSentOrder(id) {
    return super.patch(this.apiConfig.order + '/api/order/' + id + '/status/Cancel', { params: {} });
  }

  updateStatus(request) {
    return super.post(this.apiConfig.order + '/api/order/mock/status', request);
  }

  getBinaryReport(faxUrl) {
    const url = super.serviceUrl(this.apiConfig.report + faxUrl);
    return super.fetch(url,
      {
        headers: {
          accept:
            'application/octet-stream'
        },
        observe: 'response',
        responseType: 'blob' as 'json'
      }
    ).pipe(
      map((response: IResponse) => {
        if (!response.hasError && response.data) {
          return response.data;
        } else {
          return null;
        }
      })
    );

  }
  getShipments(dateField: Date) {
    return super.fetch(this.apiConfig.util + '/api/dayboard/shipment', { params: { date: moment(dateField).format(), today: true } });
  }

  getTODOTasks(dateField, taskStatus: string) {
    dateField = new Date(dateField)
    return super.fetch(this.apiConfig.hp+'/api/task/search', { params: { date:moment(dateField).format(), status: taskStatus } });
  }

  getTaskCountByDateRange(fromDate: Date, toDate: Date, status: string) {  
    return super.fetch(this.apiConfig.hp + '/api/task/countTask', {
      params: {
        status: status,
        fromDate: moment(fromDate).format(),
        toDate: moment(toDate).format()
      }
    });
  }

  getWaste(dateField: Date) {
    return super.fetch(this.apiConfig.util + '/api/dayboard/waste', { params: { date: moment(dateField).format() } });
  }

  postDataService(data) {
    return this.http.post(this.apiConfig.bin + '/api/bin', data);
  }

  putDataService(data, id) {
    return this.http.put(this.apiConfig.bin + '/api/bin/' + id, data);

  }
  deleteShipment(data) {
    return this.http.put(this.apiConfig.inventory + '/api/inventory/shipment', data);
  }
  getAdhoc(): Observable<any> {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.hp + '/api/task/adhoc');
    return super.fetch(url);
  }

  getTaskResult(taskName, instrumentId): Observable<any> {
    let url = super.serviceUrl(this.apiConfig.hp + '/api/taskresult/adhoc/search');
    if(taskName==='Sealed Source Inventory Test' || taskName==='Leak Test'){
      url = url + "?taskName=" + taskName + "&date=" + moment(this.cache.get('currDate')).format();
    }
    else if (taskName === 'Personnel' || taskName === 'Survey' || taskName === 'Wipe') {
      url = url + '?surveyGroupId=' + instrumentId + "&taskName=" + taskName + "&date=" + moment(this.cache.get('currDate')).format();
    } else {
      url = url + '?instrumentId=' + instrumentId + "&taskName=" + taskName + "&date=" + moment(this.cache.get('currDate')).format();
    }

    return super.fetch(url);
  }

  saveTask(req: any): Observable<any> {
    //temp
    const httpOptions = {
      observe: 'response' as 'response'
    };
    const request = {};
    const url = super.serviceUrl(this.apiConfig.hp + '/api/tasks/adhoc');
    return super.post(url,req,httpOptions);
  }


  getPatientVisitDetails(visitId, allDet) {
    return super.fetch(this.apiConfig.patient + '/api/patientvisit/' + visitId, { params: { allDetails: allDet } });
  }

  deletePatientComponent(patVistCompNum, visitId) {

    let url = super.serviceUrl(this.apiConfig.patient);
    url = url + '/api/patientvisit/procedure' + '?patientVisitComponentNum=' + patVistCompNum + "&patientVisitNum=" + visitId;
    return super.delete(url);
  }

  getProducts(): Observable<any> {
    //temp
    const request = {};
    const url = super.serviceUrl(this.apiConfig.inventory + '/api/product/search?type=0');
    return super.fetch(url);
  }

  getUsages() {
    const url = super.serviceUrl(this.apiConfig.config + '/config/customercatalog');
    return super.post(url, {});
  }

  getPurchaseOrders(): Observable<any> {
    //temp
    const request = {};
    const url = super.serviceUrl(this.apiConfig.config + '/config/purchaseorders');
    return super.post(url, {});
  }

  getSupplies(): Observable<any> {
    //temp
    const request = {};
    const url = super.serviceUrl(this.apiConfig.inventory + '/api/product/search?type=1%252C2%252C3');
    return super.fetch(url);
  }

  getOrderingPhysicians(): Observable<any> {
    //temp
    const request = {};
    const url = super.serviceUrl(this.apiConfig.config + '/config/orderingphysicians');
    return super.post(url, {}).pipe(
      map((res: any) => {
        res.data.forEach(physician => {
          physician.fullName = physician.lastName + " " + physician.firstName;
          physician.id = physician.orderingPhysicianNum;
        });
        return res
      })

    )
  }

  getPhysicians(): Observable<any> {
    //temp
    const request = {};
    const url = super.serviceUrl(this.apiConfig.patient + '/api/physician');
    return super.fetch(url).pipe(
      map((response: any) => {
        response.data.forEach(physician => {
          physician.fullName = physician.lastName + " " + physician.firstName;
        });
        return response;
      })
    )
  }

  saveProduct(req: any, isOfflineOrder, isAddPage): Observable<any> {
    const request = req;
    let url = '';

    if (!isAddPage) {
      url =isOfflineOrder? super.serviceUrl(this.apiConfig.order + '/api/offline/' + req.requestNum):
      super.serviceUrl(this.apiConfig.order + '/api/order/' + req.requestNum);
      return  super.put(url, req);
    } else {
      url = isOfflineOrder ? super.serviceUrl(this.apiConfig.order + '/api/offline') : super.serviceUrl(this.apiConfig.order + '/api/order');
      return super.post(url, req);
    }


  }

  saveSupply(req: any,isOfflineOrder,isAddPage): Observable<any> {
    //temp
    const request = req;
    let url = '';
    if (!isAddPage) {
      url =isOfflineOrder? super.serviceUrl(this.apiConfig.order + '/api/offline/' + req.requestNum):
      super.serviceUrl(this.apiConfig.order + '/api/order/' + req.requestNum);
      return  super.put(url, req);
    } else {
      url = isOfflineOrder ? super.serviceUrl(this.apiConfig.order + '/api/offline') : super.serviceUrl(this.apiConfig.order + '/api/order');
      return super.post(url, req);
    }
  }

  getOrderDetails(id, isOfflineOrder) {
    let url = '';
    if (isOfflineOrder) {
      url = super.serviceUrl(this.apiConfig.order + '/api/offline');
    } else {
      url = super.serviceUrl(this.apiConfig.order + '/api/order');
    }
    return super.fetch(url, { params: { id: id } });
  }


  transformData(date, items) {
    let data = [];
    let eta = '';
    let uoms = this.cache.get(CacheConstant.LocalStorage.Uoms);
    items.forEach((item, index) => {
      let calibrationDate = moment(item.calibrationDate);
      let uom = item.actUomId ? uoms.find(x => x.id === item.actUomId).name : 'undefined';
      if (index == 0) {
        eta = moment(item.calibrationDate).subtract(30, 'minutes').format('MM/DD/YYYY HH:mm');
      }
      data.push({
        sessionTime: calibrationDate.format('HH:mm'), prodName: item.prodName,
        procedureName: item.procedureName, id: item.id, componentName: item.componentName, note: item.note,
        calibrationDateTime: calibrationDate.format('MM/DD/YYYY HH:mm'),
        status: item.requestStatus ? item.requestStatus : 'Pending',
        patientName: item.patientName, referringPhysician: item.referringPhysicianName,
        actQtyWithUom: item.actQty && item.actUomId ? item.actQty + ' ' + uom : null
      });
    });

    return {
      month: moment(date).format('MMMM'), date: moment(date).format('DD'),
      data: data, eta: eta
    };
  }

  transformDataforSentUnsent(date, items, caller) {
    let dateTimeDisplayFormat = 'MM/DD/YYYY HH:mm';
    let timeDisplayFormat = 'HH:mm'
    let data = [];
    let eta = '';
    let uoms = this.cache.get(CacheConstant.LocalStorage.Uoms);

    items.forEach((item, index) => {
      let calibrationDate = item.calibrationDate ? moment(item.calibrationDate) : null;
      let uom = item.actUomId ? uoms.find(x => x.id === item.actUomId).name : 'undefined';
      let receiveDate = item.receiveDate ? moment(item.receiveDate) : null;
      if (receiveDate) {
        eta = receiveDate.format(dateTimeDisplayFormat);
      } else {
        if (index == 0 && calibrationDate) {
          eta = moment(item.calibrationDate).subtract(30, 'minutes').format(dateTimeDisplayFormat);
        }
      }
      if (caller == 'Sent' || caller == 'Unsent') {
        item.status = item.requestStatus ? item.requestStatus : "";
      }

      if (caller == 'Shipment') {
        item.actQty = item.radioActive == 'Y' ? (item.actQty) : (((item.amountQty) && (item.amountQty != -1)) ? (item.amountQty) : (item.volQty));
        item.actUomId = item.radioActive == 'Y' ? (item.origActQtyId) : (((item.amoutQtyId) && (item.amountQtyId != -1)) ? (item.amoutQtyId) : (item.volQtyId));
        item.actQtyWithUom = item.actQty && item.actUomId ? item.actQty + ' ' + uom : null;
      }
      item.orderStatus = this.getOrderStatus(item.orderStatus);
      item.referringPhysician = item.referringPhysicianName;
      item.eta = eta;
      item.sessionTime = calibrationDate ? calibrationDate.format(timeDisplayFormat) : 'N/A';
      item.calibrationDateTime = calibrationDate ? calibrationDate.format(dateTimeDisplayFormat) : 'N/A';
      item.actQtyWithUom = item.actQty && item.actUomId ? item.actQty + ' ' + uom : null;
    });
    return {
      month: moment(date).format('MMMM'), date: moment(date).format('DD'),
      data: items, eta: eta
    };


  }

  getOrderStatus(status) {
    let orderStat = {};
    orderStat["Unverified"] = "Sent";
    orderStat["Verified"] = "Accepted";
    orderStat["ForwardedOut"] = "Sent";
    orderStat["EndOfDay"] = "EOD";
    orderStat["Invoiced"] = "Invoiced";

    if (typeof orderStat[status] === "undefined") {
      return status;
    } else {
      return orderStat[status];
    }
  }

  transformTimeSlots(sessionInfo) {
    let retVal = [];
    if (sessionInfo) {
      let schedulerInfo = {};
      let timeslotInfo = sessionInfo.generatorSlotScheduleXrefDetail;
      schedulerInfo = {
        generatorSlotScheduleXrefDetail: {
          gnrtrSlotSchedXrefDtlNum: timeslotInfo.gnrtrSlotSchedXrefDtlNum,
          gnrtrSlotSchedXrefNum: timeslotInfo.gnrtrSlotSchedXrefNum,
          slotStatus: timeslotInfo.slotStatus,
          sessioNum: timeslotInfo.sessioNum,
          blockedAppNum: timeslotInfo.blockedAppNum,
          reservedUserId: timeslotInfo.reservedUserId,
          activeFlag: timeslotInfo.activeFlag,
          deleteFlag: timeslotInfo.deleteFlag,
          versionNum: timeslotInfo.versionNum,
          activity: timeslotInfo.actQty
        },
        versionXref: sessionInfo.versionXref
      };
      retVal.push(schedulerInfo);
    }

    return retVal;
  }
  saveForComponent(id, displayText): Observable<any> {
    //temp
    const httpOptions = {
      observe: 'response' as 'response'
    };
    const request = { text: displayText };
    const url = super.serviceUrl(this.apiConfig.patient + '/api/patientvisitcomponent/' + id + '/note');
    return this.http2.post(url, request, httpOptions)
  }

  saveForProcedureAndPatient(id, patientText, procedureText): Observable<any> {
    //temp
    const request = { patientText: patientText, procedureText: procedureText }
    const url = super.serviceUrl(this.apiConfig.patient + '/api/patientvisit/' + id + '/note');
    return super.post(url, request)
  }

  getNotificationDetails(data) {
    return super.post(this.apiConfig.util + '/order/reject/notification', data);
  }

  dismissMessage(retVal) {
    return super.post(this.apiConfig.util + '/order/reject/dismiss', retVal)
  }

  cancelComponent(id: any, cancelOnlySchedule: boolean) {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.patient + '/api/patientvisitcomponent/', id);
    if(cancelOnlySchedule) {
      return super.delete(url,request, { params: { "manufacturer-order": true }});
    }
    return super.delete(url);

  }

  updateStatusReschedule(patientVisitComponentId, status, isReorder): Observable<any> {
    //temp
    const request = {};
    const url = super.serviceUrl(this.apiConfig.patient + '/api/patientvisitcomponent/' + patientVisitComponentId + '/status/' + status);
    return super.put(url, request, { params: { isReorder: isReorder } });
  }

  saveNonDosingComponent(patientVisitComponent, status) {
    const url = super.serviceUrl(this.apiConfig.patient + '/api/patientvisitcomponent/' + patientVisitComponent.id + '/status/' + status);
    return super.put(url, patientVisitComponent);
  }

  rescheduleProcedure(patientVisitId, isReorder): Observable<any> {
    //temp
    const request = {};
    const url = super.serviceUrl(this.apiConfig.patient + '/api/patientVisit/' + patientVisitId + '/status');
    return super.put(url, request, { params: { isReorder: isReorder } });
  }

  saveConfig(data, typeId): Observable<any> {
    //temp
    const httpOptions = {
      observe: 'response' as 'response'
    };
    const request = data;
    const url = super.serviceUrl(this.apiConfig.config + '/api/configuration/configtype/' + typeId + '/configvalue');
    return this.http2.post(url, request, httpOptions)
  }
  getUsers() {
    const request = {};
    const url = super.serviceUrl(this.apiConfig.util+ '/api/userManagement/users?onlyActiveUsers=N');
    return super.fetch(url, request);
  }



  onDismissTask(task, dismissFlag, dismissNote, date, performedBy){
    let mobileNum = this.sessionStorage.retrieve(CacheConstant.LocalStorage.Mobile);
    let currDate = moment(date).format();
    let dismissDate = moment(
      this.datePipe.transform(currDate, DateFormat.DatePipeFormat) + ' ' + '13:00'
      ).format();
    let data = {taskSetupNum:task.taskId,
              taskType:task.taskType,
              instrumentNum:task.instrumentId,
              dismissFlag:dismissFlag,
              dismissNote: dismissNote,
              dismissTime: dismissDate,
              dismissedBy: performedBy,
              mobileNum: mobileNum?mobileNum.id:null
            };
   return super.put(this.apiConfig.hp+'/api/task/dismiss',data)
  }


  savePerformTask1(performTaskDetails, testData) {
    const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult');
    return super.post(url, this.transformPerformTaskDataGeometry(performTaskDetails, testData));
  }

  savePerformTaskforLineator(performTaskDetails, testData) {
    let transformedData=this.transformPerformTaskDataGeometry(performTaskDetails,testData);
    transformedData.factorStatus=performTaskDetails.taskData.factorStatus?!(performTaskDetails.taskData.factorStatus):true;
    const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult');
    return super.post(url, transformedData);
  }

  getPerformedTaskData(task,searchAcrossDepts?,selectedDate?: Date){
    const request = {};
    const datefld = selectedDate ? moment(selectedDate) : moment(this.cache.get('currDate'));
    
    const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult/search');
    return super.fetch(url, {params:{date:datefld.format(),searchAcrossDepts:searchAcrossDepts?searchAcrossDepts:true,taskId:task.taskId,taskState:task.type,type:task.taskType}});
  }

  getCcTaskData(task,selectedDate?: Date){
    const request = {};
    const datefld = selectedDate ? moment(selectedDate).format() : moment(this.cache.get('currDate')).format();

    const url = super.serviceUrl(this.apiConfig.hp+ '/api/channelconstancy');
    return super.fetch(url, {params:{date:datefld,instrumentTaskId:task.instrumentTaskId,taskSetupId:task.taskId}});
  }


  getAdhocPerformedTaskData(task,searchAcrossDepts?){
    const request = {};
    const datefld =moment(this.cache.get('currDate'));

    const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult/search');
    return super.fetch(url, {params:{date:datefld.format(),searchAcrossDepts:searchAcrossDepts?searchAcrossDepts:true,taskId:task.taskId,type:task.taskType}});
  }

  getBackgroundValue(dateField,taskTyp,uom){
    const url = super.serviceUrl(this.apiConfig.hp+ '/api/background/search');
    return super.fetch(url, {params:{date:moment(dateField).format('MM/DD/YYYY'),taskType:taskTyp,uomNum:uom}});
  }

  savePerformTaskForPersonnel(performTaskDetails,testData){
    let transformedData:any=this.transformPerformTaskData(performTaskDetails,testData)
    transformedData.completed=performTaskDetails.taskData.completed;
    transformedData.status=performTaskDetails.taskData.numFailed&&performTaskDetails.taskData.numFailed>0?"FAIL":"PASS";
    transformedData.ncld=performTaskDetails.taskData.ncld,
    transformedData.mobileNum= this.sessionStorage.retrieve('mobileNum');
    transformedData.tests.forEach(test=>{
      test.observedDateTime = moment(
        this.datePipe.transform(performTaskDetails.testDateTime, DateFormat.DatePipeFormat) + ' ' + test.observedTime
      ).format();
      delete test.observedDate;
      delete test.observedTime;
    })
    const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult');
      return super.post(url, transformedData);
  }

  savePerformTaskforCalicheck(performTaskDetails,testData){
    let transformedData:any= this.transformPerformTaskData(performTaskDetails,testData);
    transformedData.ncld=performTaskDetails.taskData.ncld;
    transformedData.completed=performTaskDetails.taskData.completed?performTaskDetails.taskData.completed:true;
    delete transformedData.mobileNum;
    const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult');
      return super.post(url, transformedData);
  }

  savePerformTaskforLeakTest(performTaskDetails,testData){
    performTaskDetails.background=performTaskDetails.taskData.background;
    let transformedData:any = this.transformPerformTaskData(performTaskDetails,testData);
    transformedData.ncld=performTaskDetails.taskData.ncld,
    transformedData.removableActivity=performTaskDetails.taskData.removableActivity;
    transformedData.removableActivityUom=performTaskDetails.taskData.removableActivityUom;
    delete transformedData.mobileNum;
    delete transformedData.note;
    const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult');
      return super.post(url, transformedData);
  }

savePerformTask(performTaskDetails,testData){
  const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult');
    return super.post(url, this.transformPerformTaskData(performTaskDetails,testData));
}

updatePerformTask(performTaskDetails,testData,prevExecDate){
  performTaskDetails.previousExecutionDate=prevExecDate;
  const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult/');
  return super.put(url + performTaskDetails.taskData.performtaskId, this.transformPerformTaskData(performTaskDetails,testData));
}

saveCcTask(dataToSave, instrumentTaskId, matches){
  const req = this.transformCcData(dataToSave, instrumentTaskId, matches);
  const url = super.serviceUrl(this.apiConfig.hp+ '/api/channelconstancy');
  return super.post(url, req);
}

deleteCcTest(id){
  const url = super.serviceUrl(this.apiConfig.hp+ '/api/channelconstancy/', id);
    return super.delete(url);
}

updatePerformTaskForPersonnel(performTaskDetails,testData, prevExecDate){
  let transformedData:any=this.transformPerformTaskData(performTaskDetails,testData)
  transformedData.completed=performTaskDetails.taskData.completed;
  transformedData.status=performTaskDetails.taskData.numFailed&&performTaskDetails.taskData.numFailed>0?"FAIL":"PASS";
  transformedData.ncld=performTaskDetails.taskData.ncld;
  delete transformedData.mobileNum;
  if(performTaskDetails.disabled){
    transformedData.flow="UPDATE";
    transformedData.prevExecDate=prevExecDate;
  }
  transformedData.tests.forEach(test=>{
    test.observedDateTime = moment(
      this.datePipe.transform(performTaskDetails.testDateTime, DateFormat.DatePipeFormat) + ' ' + test.observedTime
    ).format();
    delete test.observedDate;
    delete test.observedTime;
  })
  const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult/');
    return super.put(url+performTaskDetails.taskData.performtaskId,transformedData);
}


saveForDecay(performTaskDetails,testData){
  let transformedData=this.transformPerformTaskDataGeometry(performTaskDetails,testData);
  transformedData.factorStatus=performTaskDetails.taskData.factorStatus?!(performTaskDetails.taskData.factorStatus):true;
  transformedData.wipeAreaSize=null;
  transformedData.status='FAIL';
  transformedData.tests.forEach((test,index)=>{
    test.dateOnly=moment(test.dateOnly).format('MM/DD/YYYY');
    test.sequence=index;
    test.observedDateTime=moment(
      this.datePipe.transform(test.dateOnly, DateFormat.DatePipeFormat) + ' ' + test.timeOnly
    ).format();
    test.net=parseInt(test.net);
  })
  transformedData.completed=performTaskDetails.taskData.completed;
  delete transformedData.mobileNum;

  const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult/');
  return super.put(url+performTaskDetails.taskData.performtaskId,transformedData);

}

savePerformTaskforDecay(performTaskDetails, testData) {
  let transformedData=this.transformPerformTaskDataGeometry(performTaskDetails,testData);
  transformedData.factorStatus=performTaskDetails.taskData.factorStatus?!(performTaskDetails.taskData.factorStatus):true;
  transformedData.wipeAreaSize=null;
  transformedData.tests.forEach((test,index)=>{
    test.dateOnly=moment(test.dateOnly).format('MM/DD/YYYY');
    test.sequence=index;
    test.observedDateTime=moment(
      this.datePipe.transform(test.dateOnly, DateFormat.DatePipeFormat) + ' ' + test.timeOnly
    ).format();
    test.net=parseInt(test.net);
    delete test.backGroundError;
    delete test.readingError;
    delete test.uomError;
    delete test.validError;
  })
  transformedData.completed=performTaskDetails.taskData.completed;
  delete transformedData.mobileNum;
  const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult');
  return super.post(url, transformedData);
}

deleteTest(performtaskId,taskType){
  const url = super.serviceUrl(this.apiConfig.hp+ '/api/taskresult/', performtaskId+'?type='+taskType);
  return super.delete(url);
}



  getSource(taskType) {
    return super.fetch(this.apiConfig.inventory + '/api/inventory/source', { params: { searchAcrossDepts: true } }).pipe(map((response: IResponse) => {
      return this.transformInventories(response.data, taskType);
    }));
  }

  getInativeSource() {
    return super.fetch(this.apiConfig.inventory + '/api/inventory/inactivesource');
  }

  transformInventories(sources, taskType) {
    var retVal = { expiredInvs: [], sources: [] };
    sources.forEach((mySource) => {
      if (taskType != "Leak Test" && this.isExpiredSource(mySource)) {
        retVal.expiredInvs.push(mySource);
      }
      else if (taskType == "Accuracy") {
        mySource.label = mySource.productName + "-" + mySource.serialNum;
        retVal.sources.push(mySource)
      } else {
        retVal.sources.push(mySource);
      }
    });
    return retVal;
  }
  isotopeDecayBetweenTwoDates(originalActivity, originalDate, finalDate, lambdaDays) {
    let deltaDays = (finalDate - originalDate) / 86400000;
    return (originalActivity * Math.exp((-lambdaDays) * deltaDays));
  }
  isExpiredSource(source) {
    return !source.expiryDate ? false : (new Date().getTime() > new Date(source.expiryDate).getTime());
  }

transformPerformTaskData(performTaskDetails,testData){
    let date = this.cache.get('currDate')
    if(!performTaskDetails.scheduleDate){
      performTaskDetails.scheduleDate = moment(date).format();
    }
    if(!performTaskDetails.nextDue || performTaskDetails.nextDue == 'Invalid date'){
      performTaskDetails.nextDue = moment(new Date()).format(DateFormat.DMDYHHMM);
    }
    const mob=this.cache.get(CacheConstant.LocalStorage.Mobile)
    return{
      type:performTaskDetails.task,
   performedBy:this.getperformedBy(performTaskDetails.performedBy),
   note:performTaskDetails.notes?performTaskDetails.notes:'',
   testDateTime:performTaskDetails.testDateTime,
   taskDue:moment(performTaskDetails.nextDue).format(),
   scheduledDate:performTaskDetails.scheduleDate,
   lastPerformed:performTaskDetails.testDateTime,
   efficiency:performTaskDetails.taskData.efficiency?parseFloat(performTaskDetails.taskData.efficiency):null,
   background:performTaskDetails.background?parseFloat(performTaskDetails.background):null,
   instrument:performTaskDetails.taskData.instrument?{
      id:performTaskDetails.taskData.instrument.id
   }:null,
   actualValUom:performTaskDetails.taskData.instrument?performTaskDetails.taskData.instrument.uom:null,
   id:performTaskDetails.id,
   tests:testData,
   voltage:performTaskDetails.voltage?parseInt(performTaskDetails.voltage):null,
   factorStatus:performTaskDetails.taskData.factorStatus?(!performTaskDetails.taskData.factorStatus):true,
   status:performTaskDetails.numFailed && performTaskDetails.numFailed>0?'FAIL':'PASS',
   completed:true,
   taskSetup:performTaskDetails.id,
   taskExecStatus:testData[0].result,
   wipeAreaSize:performTaskDetails.wipeAreaSize?Number(performTaskDetails.wipeAreaSize):null,
   mobileNum:mob?mob.id:null,
   flow:performTaskDetails.disabled?'UPDATE':'',
   prevExecDate:performTaskDetails.previousExecutionDate
    }
  }

  transformPerformTaskDataGeometry(performTaskDetails, testData) {
    let date = this.cache.get('currDate')
    if(!performTaskDetails.scheduleDate){
      performTaskDetails.scheduleDate = moment(date).format();
    }
    if(!performTaskDetails.nextDue || performTaskDetails.nextDue == 'Invalid date'){
      performTaskDetails.nextDue = moment(new Date()).format(DateFormat.DMDYHHMM);
    }
    return {
      type: performTaskDetails.task,
      performedBy:this.getperformedBy(performTaskDetails.performedBy),
      note: performTaskDetails.notes,
      testDateTime: performTaskDetails.testDateTime,
      taskDue: moment(performTaskDetails.nextDue).format(),
      scheduledDate:performTaskDetails.scheduleDate,
      lastPerformed: performTaskDetails.testDateTime,
      efficiency: performTaskDetails.taskData.efficiency ? performTaskDetails.taskData.efficiency : null,
      background: performTaskDetails.taskData.background ? performTaskDetails.taskData.background : null,
      instrument: performTaskDetails.taskData.instrument ? {
        id: performTaskDetails.taskData.instrument.id
      } : null,
      ncld: performTaskDetails.taskData.ncld ? performTaskDetails.taskData.ncld :
        {
          desc: "Actinium",
          halfLife: 9.9203,
          halfLifeUom: 23,
          id: 223,
          lambda: 0.0698567584,
          name: "Ac-225"
        },
      otherTestSetupDesc: performTaskDetails.taskData.otherTestSetupDesc,
      actualValUom: performTaskDetails.taskData.instrument ? performTaskDetails.taskData.instrument.uom : null,
      id: performTaskDetails.id,
      tests: testData,
      voltage: performTaskDetails.voltage?parseInt(performTaskDetails.voltage):null,
      factorStatus: true,
      status: performTaskDetails.numFailed && performTaskDetails.numFailed > 0 ? 'FAIL' : 'PASS',
      completed: true,
      taskSetup: performTaskDetails.id,
      taskExecStatus: testData[0].result,
      wipeAreaSize: performTaskDetails.wipeAreaSize ? Number(performTaskDetails.wipeAreaSize) : null,
      mobileNum: null
    }
  }

  getperformedBy(perfromedBy){
    let prformdBy=null;
    if(perfromedBy.id){
        prformdBy=perfromedBy.fullName;
    }else{
      prformdBy=perfromedBy;
    }
    return prformdBy;
  }
  transformTestData(testData) {
    let retVal = [];
    testData.forEach((test, index) => {
      let testDta = {
        id: test.id,
        areaName: test.areaName,
        actionLevel: test.actionLevel,
        observedReading: test.observedReading,
        net: test.net,
        result: test.result,
        areaMasterXrefNum: test.areaMasterXrefNum,
        sequence: index,
        notCompatible: false,
        netResultUom: test.netResultUom,
        expectedValUom: test.expectedValUom,
        actualValUom: test.actualValUom,
        expectedVal: test.expectedVal
      };
      retVal.push(testDta);
    });
    return retVal
  }

  transformCcData(data, instrumentTaskId, matches) {
    data.instrumentTaskId=instrumentTaskId;
    data.performer=data.performer.fullName;
    data.testSetups=this.transformSetups(data.testSetups);
    data.scheduledDate=moment(data.scheduledDate).format();
    data.date = new Date(data.date);
    data.dateFormat = 'MM/DD/YYYY HH:mm';
    data.matches = matches;
    delete data.performedBy;
    delete data.uoms;
    delete data.timeOnly;
    delete data.dateOnly;
    return data;
  }

  transformSetups(data){
    let retVal=[];
    data.forEach(value => {
      retVal.push({id:value.id,details:this.transformDetails(value.details)});
    });
    return retVal;
  }

  transformDetails(data){
    let retVal = [];
    data.forEach((value, i) => {
      retVal.push({currentReading:parseFloat(value.currentReading),baseValue:value.baseValue,testSequence:i,
      baseValueUom:(value.uom)?value.uom.id:null,currentReadingUom:(value.uom)?value.uom.name:null,variance:value.variance,testDetailSetup:{id:value.id},error:value.error,status:value.status});
    });
    return retVal;
  }

  saveNextScheduledComponent(id,data){
    const url = super.serviceUrl(this.apiConfig.patient+'/api/patientvisit/next-component/' + id);
    return super.post(url, data);
  }

  cancelAllComp(id,data){
    const url = super.serviceUrl(this.apiConfig.patient+'/api/patientvisitcomponent/cancel/theranostics?pvid='+id);
    return super.put(url,data);
  }

  cancelUnscheduledComp(Pvid,Pcid,data){
    const url = super.serviceUrl(this.apiConfig.patient+'/api/patientvisitcomponent/cancel/theranostics?pvid='+Pvid+'&pcid='+Pcid)
    return super.put(url, data);
  }

  cancelSceduledComp(id,data){
    const url = super.serviceUrl(this.apiConfig.patient+'/api/patientvisitcomponent/cancel/theranostics?pvcid='+id);
    return super.put(url,data);
  }

  getDateAccNumber() {
    const date = this._dashboardDate;
    const onlyDate = moment(date).format(DateFormat.YYYYMMDD);
    const isPastDate = moment(onlyDate).isBefore(moment().format(DateFormat.YYYYMMDD),'day');
    let utcDate = null;
    const eodTimeforPastDate = "23:59:59";
    if(isPastDate){
       utcDate = moment(onlyDate + " " + eodTimeforPastDate).format(DateFormat.YYYYMMDDTHHMMSS);
    }
    else{
      utcDate = moment(onlyDate).endOf('day').utc().format();
    }

    const data = {
      date: utcDate,
      customerShipToNum: this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo),
    }
    return data;
  }

  getRejectedNotificationDetails(reqPayload) {
    const url = super.serviceUrl(this.apiConfig.util + OrderApi.getRejectedNotificationDetails);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  acknowledgeRejectNotification(reqPayload){
    const url = super.serviceUrl(this.apiConfig.util + OrderApi.acknowledgeRejectNotification);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  getNewRejectNotificationPreference(){
    let RejectNotificationModuleFlag: any = {};
    if (this.sessionStorage.retrieve(CacheConstant.SessionStorageData.NuctracAppPreferences)) {
      RejectNotificationModuleFlag = (this.sessionStorage.retrieve(CacheConstant.SessionStorageData.NuctracAppPreferences).filter((obj) => {
        return obj.preferenceKey.indexOf("NEW_REJECT_NOTIFICATION_MODULE_FLAG") !== -1;
      }))[0];
    }
     let showNewRejectNotification =  RejectNotificationModuleFlag && (RejectNotificationModuleFlag.preferenceValue == 'Y');
     return showNewRejectNotification;
  }

  getRejectedRequestNotification(){
    let payload = this.getDateAccNumber();
    return this.getRejectedNotificationDetails(payload).
    pipe(map((response:IResponse) => {
        if(!response.hasError && response.data != null){
          let rejectedNotificationData = [];
            response.data.map((item,index) => {
              rejectedNotificationData[index] = (item);
              rejectedNotificationData[index].calibrationTime = moment(new Date(item.calibrationTime)).format(DateFormat.HHMM);
              rejectedNotificationData[index].rejectTime = moment(new Date(item.rejectTime)).format(DateFormat.MMDDYYYYHMM)
            })
        }
        return response;
      }));
  }

  async openRejectNotificationDialog(rejectionNotificationData) {

    const { RejectNotificationComponent } = await import(
      'src/app/common/header/reject-notification/reject-notification.component'
    );

    this.dialog
    .open(RejectNotificationComponent, {
      disableClose:true,
      data: rejectionNotificationData,
      panelClass: 'rejected-request',
      hasBackdrop: true,
      width: '60%',
      autoFocus: false,
      restoreFocus: false
    })
    .afterClosed().subscribe((result) => {
    });
  }

  sortBasedOnMillisecOfDate(tasks, dateType){
    let sortedTasks = JSON.parse(JSON.stringify(tasks));
    if(tasks && tasks.length > 0){
      sortedTasks.sort((task1, task2) =>
        this.getMillisOfTheDay(task1[dateType]) - this.getMillisOfTheDay(task2[dateType]));
    }
    return sortedTasks;
  }
  getMillisOfTheDay(dateForSort){
    let originalDateString= moment(dateForSort).format();
    let hours = moment(originalDateString).get('hours');
    let minutes = moment(originalDateString).get('minutes');
    let seconds = moment(originalDateString).get('seconds');
    let milliSecForDay = ((hours*60+minutes)*60+seconds)*1000;
    return milliSecForDay;
  }

  send340BPDFEmail(reqPayload: any)
  {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.sendEmail340BEntityFormPDF);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  getWrittenDirectiveByPatientVisitComponentId(patientVisitComponentId: number) {
    return super.fetch(this.apiConfig.patient + '/api/written-directives?patient-visit-component-id=' + patientVisitComponentId);
  }

  getWrittenDirectiveForm(patientVisitComponentId?: number, writtenDirectiveFormId?: number) {
      const params = new URLSearchParams();

      if (patientVisitComponentId != null) {
        params.set('patient-visit-component-id', patientVisitComponentId.toString());
      } else if (writtenDirectiveFormId != null) {
        params.set('written-directive-form-id', writtenDirectiveFormId.toString());
      }
      return super.fetch(`${this.apiConfig.patient}/api/written-directives?${params.toString()}`);
  }

  saveWrittenDirectiveForm(writtenDirectiveFormData){
    return super.post(this.apiConfig.patient + '/api/written-directives', writtenDirectiveFormData);
  }

  updateWrittenDirectiveForm(writtenDirectiveFormData, writtenDirectiveFormId) {
    return super.put(this.apiConfig.patient + '/api/written-directives/' + writtenDirectiveFormId, writtenDirectiveFormData);
  }
  deleteWrittenDirectiveForm(writtenDirectiveFormId) {
    return super.delete(this.apiConfig.patient + '/api/written-directives/' + writtenDirectiveFormId);
  }
}
